/* Retouches STAY. (petit fichier chargé après theme.js) */
(function(){
  // Pastilles des cartes de l'accueil : changent la photo et le lien
  document.addEventListener('click', function(e){
    var sw = e.target.closest('[data-swatch-name]');
    if(!sw) return;
    e.preventDefault();
    var card = sw.closest('.card'); if(!card) return;
    card.querySelectorAll('[data-swatch-name]').forEach(function(b){ b.classList.toggle('is-active', b === sw); });
    var img = card.querySelector('.card__media img:not(.card__img--hover)');
    if(img && sw.dataset.swatchImg){
      img.removeAttribute('srcset');
      if(sw.dataset.swatchSrcset){ img.setAttribute('srcset', sw.dataset.swatchSrcset); }
      img.src = sw.dataset.swatchImg;
    }
    var url = sw.dataset.swatchUrl;
    if(url){ card.querySelectorAll('a.card__media, a.card__title, a.btn').forEach(function(a){ a.href = url; }); }
    var label = card.querySelector('[data-swatch-label]');
    if(label){ label.textContent = sw.dataset.swatchName; }
  });

  // Page Sweats : la pastille change la photo (CSS) + le lien vers la bonne couleur
  document.addEventListener('change', function(e){
    var r = e.target; if(!r.matches || !r.matches('.pc input[type="radio"]')) return;
    var card = r.closest('.pc'); var lab = card.querySelector('label[for="'+r.id+'"]'); if(!lab) return;
    var url = lab.dataset.pcUrl;
    if(url){ card.querySelectorAll('.ph > a, a.pc__title, a.btn').forEach(function(a){ a.href = url; }); }
    var label = card.querySelector('[data-swatch-label]'); if(label){ label.textContent = lab.dataset.pcName; }
  });

  // Page Sweats : au chargement, les liens de chaque carte mènent à la couleur affichée
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.pc input[type="radio"]:checked').forEach(function(r){
      var card = r.closest('.pc'); var lab = card && card.querySelector('label[for="'+r.id+'"]');
      if(lab && lab.dataset.pcUrl){ card.querySelectorAll('.ph > a, a.pc__title, a.btn').forEach(function(a){ a.href = lab.dataset.pcUrl; }); }
    });
  });

  // Fiche produit : affiche le nom STAY. de la couleur choisie (Crème au lieu d'Abricot clair...)
  document.addEventListener('change', function(e){
    var r = e.target; if(!r.matches || !r.matches('[data-option-index] input[data-label]')) return;
    var fs = r.closest('[data-option-index]'); var lab = fs && fs.querySelector('[data-selected-value]');
    if(lab){ lab.textContent = r.dataset.label; }
  });

  // Fiche produit : galerie. La grande photo suit la couleur ; on fait défiler les photos
  // directement dessus (flèches, glisser du doigt, clavier) ; petites vignettes dessous.
  function pgInit(pg){
    var all = []; try { all = JSON.parse(pg.querySelector('[data-pg-media]').textContent); } catch(e){ return; }
    var main = pg.querySelector('[data-pg-main]') || pg.querySelector('.pg__main img:not(.pg__hover)'), hover = pg.querySelector('[data-pg-hover]') || pg.querySelector('.pg__main .pg__hover');
    var stage = pg.querySelector('.pg__main'), thumbs = pg.querySelector('[data-pg-thumbs]'), count = pg.querySelector('[data-pg-count]');
    var norm = function(t){ return (t||'').toString().trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,''); };
    var alias = {'abricot clair':'creme','beige camel':'kaki-clair','gris anthracite':'kaki-fonce'};
    var slug = function(c){ c = norm(c); return alias[c] || c.replace(/\s+/g,'-'); };
    var fname = function(u){ return (u||'').split('?')[0].split('/').pop(); };
    var list = all.slice(), idx = 0;
    function setImg(img, m){ if(!img || !m) return; img.removeAttribute('srcset'); if(m.s6 && m.s9){ img.setAttribute('srcset', m.s6+' 600w, '+m.s9+' 900w, '+m.src+' 1400w'); } img.src = m.src; img.alt = m.alt || ''; }
    function show(i){
      if(!list.length) return;
      idx = (i + list.length) % list.length;
      setImg(main, list[idx]);
      pg.classList.toggle('is-picked', idx !== 0);
      if(count){ count.textContent = (idx + 1) + ' / ' + list.length; }
      if(thumbs){
        var bs = thumbs.querySelectorAll('[data-pg-thumb]');
        bs.forEach(function(b, j){ b.classList.toggle('is-on', j === idx); });
        var on = bs[idx];
        if(on){ var l = on.offsetLeft - thumbs.offsetLeft, r = l + on.offsetWidth; if(l < thumbs.scrollLeft || r > thumbs.scrollLeft + thumbs.clientWidth){ thumbs.scrollTo({ left: l - 8, behavior: 'smooth' }); } }
      }
    }
    function build(){
      if(thumbs){
        thumbs.innerHTML = '';
        list.forEach(function(m, i){
          var b = document.createElement('button'); b.type = 'button'; b.className = 'pg__thumb'; b.setAttribute('data-pg-thumb',''); b.setAttribute('aria-label','Voir la photo '+(i+1));
          var im = document.createElement('img'); im.loading = 'lazy'; im.src = m.s6 || m.src; im.alt = m.alt || ''; b.appendChild(im);
          b.addEventListener('click', function(){ show(i); });
          thumbs.appendChild(b);
        });
        thumbs.scrollLeft = 0;
      }
      pg.classList.toggle('pg--single', list.length <= 1);
      show(0);
    }
    function apply(color){
      var group = [];
      if(color){
        var s = slug(color), re = new RegExp('-' + s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + '-(\\d+)-');
        all.forEach(function(m){ var r = fname(m.src).match(re); if(r){ m.n = parseInt(r[1],10); group.push(m); } });
      }
      if(!group.length){
        list = all.slice();
        if(hover && all[1]){ setImg(hover, all[1]); hover.style.display=''; }
      } else {
        group.sort(function(a,b){ return a.n - b.n; });
        var m9 = group.filter(function(m){ return m.n === 9; })[0] || group[0];
        var m8 = group.filter(function(m){ return m.n === 8; })[0] || group.filter(function(m){ return m !== m9; })[0];
        list = [m9].concat(m8 ? [m8] : []).concat(group.filter(function(m){ return m !== m9 && m !== m8; }));
        if(hover){ if(m8){ setImg(hover, m8); hover.style.display=''; } else { hover.style.display='none'; } }
      }
      build();
    }
    var ci = parseInt(pg.dataset.colorIndex, 10);
    var root = pg.closest('[data-product-root]') || document;
    if(ci >= 0){
      root.addEventListener('change', function(e){
        var fs = e.target.closest && e.target.closest('[data-option-index="'+ci+'"]');
        if(fs && e.target.checked){ apply(e.target.value); }
      });
      var checked = root.querySelector('[data-option-index="'+ci+'"] input:checked');
      apply(checked ? checked.value : pg.dataset.startColor);
    } else { apply(''); }
    var prev = pg.querySelector('[data-pg-prev]'), next = pg.querySelector('[data-pg-next]');
    prev && prev.addEventListener('click', function(e){ e.preventDefault(); show(idx - 1); });
    next && next.addEventListener('click', function(e){ e.preventDefault(); show(idx + 1); });
    // Glisser du doigt sur la grande photo (téléphone)
    if(stage){
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function(e){
        if(x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
        if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){ show(dx < 0 ? idx + 1 : idx - 1); }
      });
      stage.tabIndex = 0;
      stage.addEventListener('keydown', function(e){ if(e.key === 'ArrowRight'){ show(idx + 1); } else if(e.key === 'ArrowLeft'){ show(idx - 1); } });
    }
  }
  document.addEventListener('DOMContentLoaded', function(){ document.querySelectorAll('[data-pg]').forEach(pgInit); });

  // Fiche produit : « Offrir ce message » ajoute le pull choisi au panier puis ouvre le panier
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-gift-add]'); if(!b) return;
    e.preventDefault();
    var root = b.closest('[data-product-root]') || document;
    var form = root.querySelector('form[data-product-form]'); if(!form) return;
    var add = form.querySelector('[data-add-button]');
    if(add && add.disabled) return;
    b.disabled = true;
    var base = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function(r){ if(!r.ok) throw new Error('add'); location.href = b.dataset.cartUrl || (base + 'cart'); })
      .catch(function(){ b.disabled = false; alert('Oups, le pull n’a pas pu être ajouté. Réessaie.'); });
  });

  // Fiche produit : présélectionne la couleur reçue dans l'adresse (?couleur=Noir)
  document.addEventListener('DOMContentLoaded', function(){
    var wanted = new URLSearchParams(location.search).get('couleur');
    if(!wanted) return;
    var norm = function(t){ return (t||'').toString().trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,''); };
    var target = norm(wanted);
    var inputs = document.querySelectorAll('input[type="radio"]');
    for(var i=0;i<inputs.length;i++){
      if(norm(inputs[i].value) === target || norm(inputs[i].dataset.label) === target){ if(!inputs[i].checked){ inputs[i].click(); } break; }
    }
  });
  // Bande de photos : charge toutes les photos quand la bande approche (sinon elles apparaissent en retard en défilant)
  function stripInit(){
    document.querySelectorAll('.strip').forEach(function(s){
      var load = function(){ s.querySelectorAll('img[loading="lazy"]').forEach(function(i){ i.loading = 'eager'; }); };
      if(!('IntersectionObserver' in window)){ load(); return; }
      var o = new IntersectionObserver(function(es){ if(es[0].isIntersecting){ load(); o.disconnect(); } }, { rootMargin: '900px 0px' });
      o.observe(s);
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', stripInit); } else { stripInit(); }

  // Bande de photos : défile toute seule ET se fait glisser au doigt (ou à la souris)
  function stripSwipe(){
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.strip').forEach(function(s){
      var track = s.querySelector('.strip__track'); if(!track) return;
      s.classList.add('is-js');
      var secs = parseFloat(getComputedStyle(track).getPropertyValue('--speed')) || 80;
      var pos = 0, last = 0, paused = false, resume = null, auto = false;
      var half = function(){ return track.scrollWidth / 2; };
      function wrap(){ var h = half(); if(h <= 0) return; if(pos >= h){ pos -= h; } else if(pos < 0){ pos += h; } }
      function step(t){
        if(!last) last = t;
        var dt = Math.min(t - last, 64); last = t;
        if(!paused && !still){ auto = true; pos += half() / secs * dt / 1000; wrap(); s.scrollLeft = pos; }
        requestAnimationFrame(step);
      }
      function hold(){ paused = true; clearTimeout(resume); }
      function release(){ clearTimeout(resume); resume = setTimeout(function(){ pos = s.scrollLeft; paused = false; }, 1800); }
      s.addEventListener('scroll', function(){
        if(auto){ auto = false; return; }
        pos = s.scrollLeft; var h = half();
        if(h > 0 && (pos >= h || pos <= 0)){ wrap(); s.scrollLeft = pos; }
      }, { passive: true });
      s.addEventListener('touchstart', hold, { passive: true });
      s.addEventListener('touchend', release, { passive: true });
      s.addEventListener('mouseenter', hold);
      s.addEventListener('mouseleave', release);
      // Souris : on peut aussi attraper la bande et la faire glisser
      var down = false, x0 = 0, p0 = 0;
      s.addEventListener('mousedown', function(e){ down = true; x0 = e.clientX; p0 = s.scrollLeft; s.classList.add('is-drag'); e.preventDefault(); });
      window.addEventListener('mousemove', function(e){ if(!down) return; s.scrollLeft = p0 - (e.clientX - x0); });
      window.addEventListener('mouseup', function(){ if(!down) return; down = false; s.classList.remove('is-drag'); });
      requestAnimationFrame(step);
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', stripSwipe); } else { stripSwipe(); }
})();
